import { RenderCategoryPageLayoutElements } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryPageLayoutElements";
import { useCategoryLayoutElementsLoadTiming } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useCategoryLayoutElementsLoadTiming";
import { useGetCategoryPageLayoutElementsByPlacement } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useGetCategoryPageLayoutElementsByPlacement";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React from "react";

export const CategoryPageLayoutElements = ({
  placement,
  hubCategoryPageLoadTimingRef,
}: {
  placement: ILayoutElement.Placement;
  hubCategoryPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}) => {
  const getCategoryPageLayoutElementsByPlacement =
    useGetCategoryPageLayoutElementsByPlacement();
  const layoutElements = getCategoryPageLayoutElementsByPlacement(placement);

  useCategoryLayoutElementsLoadTiming(placement);

  return (
    <div ref={hubCategoryPageLoadTimingRef}>
      <RenderCategoryPageLayoutElements layoutElements={layoutElements} />
    </div>
  );
};
